export const pageQuery = `*[_type == "page" && route.slug.current == $slug][0]{
  ...,
  content[] {
    ...,
    image {
      ...,
      asset->
    },
    mobileImage {
      ...,
      asset->
    },
    accordionItems[] {
      ...,
      image {
        ...,
        asset->
      }
    },
    stacks[] {
      ...,
      content[] {
        ...,
        image {
          ...,
          asset->
        }
      }
    },
    images[] {
      ...,
      asset->
    },
    lockingScrollItems[] {
      ...,
      image {
        ...,
        asset->
      }
    },
    illustration->,
    marquee->,
    marketoForm->,
    profileCollection->,
    pricing->,
    emailFloater-> {
      ...,
      cta {
        ...,
        iterablePopup->
      }
    },
    categories[]-> {
      ...,
      faqItems[]->
    },
    providerSearch->
  },
  navMenu->,
  footerMenu-> {
    ...,
    socialIcons[]->
  }
}`;

export const siteSettingsQuery = `*[_type == "siteSettings"][0]{
  ...
}`;
